import { render } from "./ExampleComponent.vue?vue&type=template&id=0c1a8760"
import script from "./ExampleComponent.vue?vue&type=script&lang=js"
export * from "./ExampleComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/clients/client1/web11/web/jcinternal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__